"use strict";

(function () {
  /*
   * Loads the video for the slide currently in view and plays it, pausing every other slide.
   * The videos sit inside <deferred-media>, so nothing is fetched until this runs. That is what
   * keeps the homepage free of video bytes until a card is actually clicked.
   */
  function playActiveSlide(swiper) {
    swiper.slides.forEach(function (slide, index) {
      if (index === swiper.activeIndex) return;
      const other = slide.querySelector("video");
      if (other) other.pause();
    });

    const slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;

    const media = slide.querySelector("deferred-media");
    if (media) media.loadContent();

    const video = slide.querySelector("video");
    if (!video) return;

    video.muted = false;

    const playing = video.play();
    if (!playing) return;

    playing.catch(function () {
      /*
       * Browsers refuse playback with sound unless the page has user activation, and the rules
       * differ across Chrome, Safari and any embedded webview. Swallowing that rejection leaves a
       * dead player the visitor cannot recover from, so fall back to muted: the clip runs, and the
       * native controls can turn the sound on because that click is itself an activation.
       */
      video.muted = true;
      const retry = video.play();
      if (retry) retry.catch(function () {});
    });
  }

  function initSection(root) {
    const cardsEl = root.querySelector("[data-kol-swiper]");
    if (!cardsEl || cardsEl.swiper) return;

    new Swiper(cardsEl, {
      slidesPerView: 1.8,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        prevEl: root.querySelector("[data-kol-prev]"),
        nextEl: root.querySelector("[data-kol-next]"),
      },
      breakpoints: {
        750: { slidesPerView: 3, spaceBetween: 16 },
        990: { slidesPerView: 4, spaceBetween: 16 },
        1200: { slidesPerView: 5, spaceBetween: 16 },
      },
    });

    /*
     * <modal-dialog> moves itself onto document.body when it connects, so the modal is looked up
     * by id from the document rather than from inside the section.
     *
     * In the theme editor the section is re-rendered on every setting change, but the modal it
     * already moved onto body is not torn down with it. That leaves two elements sharing an id and
     * querySelector would return the stale one, so keep the newest and drop the rest.
     */
    const modals = document.querySelectorAll(cardsEl.dataset.kolModal);
    const modal = modals[modals.length - 1];
    if (!modal) return;
    modals.forEach(function (stale) {
      if (stale !== modal) stale.remove();
    });

    const modalEl = modal.querySelector("[data-kol-modal-swiper]");
    if (!modalEl || modalEl.swiper) return;

    const modalSwiper = new Swiper(modalEl, {
      slidesPerView: 1,
      watchOverflow: true,
      navigation: {
        prevEl: modal.querySelector("[data-kol-modal-prev]"),
        nextEl: modal.querySelector("[data-kol-modal-next]"),
      },
      on: {
        slideChange: function () {
          playActiveSlide(this);
        },
      },
    });

    root.querySelectorAll("[data-kol-index]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (typeof modal.show !== "function") return;

        modal.show(button);

        /*
         * The modal swiper is built while the modal is display:none, so every slide measures zero.
         * update() has to run once the modal is visible or slideTo lands on the wrong slide.
         */
        modalSwiper.update();
        modalSwiper.slideTo(Number(button.dataset.kolIndex), 0);

        /*
         * slideChange does not fire when the requested slide is already active, so play directly.
         * Calling play twice is a no-op, so the overlap with the slideChange handler is harmless.
         */
        playActiveSlide(modalSwiper);
      });
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(".custom-kol-video")
      .forEach(function (root) {
        initSection(root);
      });
  }

  if (typeof Swiper === "undefined") return;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
